import { AggregationGroup } from 'src/app/services/jsonrpc/stats-server.service';
import { AnalyticsMetric } from 'src/app/services/stats.service';

import { Dashboard } from './dashboard.component';

const content: Dashboard = {
  widgets: [
    {
      size: 3,
      component: 'users'
    },
    {
      size: 3,
      component: 'usersPeak'
    },
    {
      size: 3,
      component: 'usersPeakDate'
    },
    {
      size: 3,
      component: 'totalActiveTime'
    },

    {
      size: 12,
      component: 'multiTable',
      settings: {
        title: 'Overview',
        grouping: null,
        rows: [
          { title: 'Registered Users', metric: AnalyticsMetric.users },
          { title: 'Active Users', metric: AnalyticsMetric.active_users },
          { title: 'Games Played', metric: AnalyticsMetric.games_played },
          { title: 'Total Active Time', metric: AnalyticsMetric.time },
          { title: '... of it Quiz', metric: AnalyticsMetric.time, filter: { [AggregationGroup.feature]: 'quiz' } },
          { title: '... of it Wiki', metric: AnalyticsMetric.time, filter: { [AggregationGroup.feature]: 'wiki' } },
          { title: '... of it Flashcard', metric: AnalyticsMetric.time, filter: { [AggregationGroup.feature]: 'flashcard' } }
        ],
        totalColumn: true
      }
    },

    {
      size: 12,
      component: 'transitionGraph'
    },

    {
      component: 'barChart',
      settings: {
        title: 'Users by licence',
        metric: AnalyticsMetric.users,
        grouping: AggregationGroup.licences
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Users by region',
        metric: AnalyticsMetric.users,
        grouping: 'label_region'
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Active Hours',
        subtitle: 'Total time in hours spent in the app over the day',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: AggregationGroup.hour,
        labelNames: '{value}:00'
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Daily Playtime',
        subtitle: 'Total recent time in hours spent in the app',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: AggregationGroup.date,
        timespan: { days: 21 }
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Weekly Playtime',
        subtitle: 'Total recent time in hours spent in the app',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: [AggregationGroup.year, AggregationGroup.week],
        timespan: { weeks: 12 }
      }
    },

    {
      component: 'lineGraph',
      settings: {
        title: 'Monthly Playtime',
        subtitle: 'Total recent time in hours spent in the app',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.feature,
        grouping: [AggregationGroup.year, AggregationGroup.month],
        timespan: { months: 12 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Monthly Playtime by type',
        subtitle: 'Time displayed in hours (hh:mm:ss)',
        metric: AnalyticsMetric.time,
        datasets: 'label_type',
        grouping: [AggregationGroup.year, AggregationGroup.month],
        timespan: { months: 12 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Monthly Playtime by licence',
        subtitle: 'Time displayed in hours (hh:mm:ss)',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.licences,
        grouping: [AggregationGroup.year, AggregationGroup.month],
        timespan: { months: 12 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Monthly Users by type',
        metric: AnalyticsMetric.active_users,
        datasets: 'label_type',
        grouping: [AggregationGroup.year, AggregationGroup.month],
        timespan: { months: 12 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Monthly Users by licence',
        metric: AnalyticsMetric.active_users,
        datasets: AggregationGroup.licences,
        grouping: [AggregationGroup.year, AggregationGroup.month],
        timespan: { months: 12 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Weekly Playtime by type',
        subtitle: 'Time displayed in hours (hh:mm:ss)',
        metric: AnalyticsMetric.time,
        datasets: 'label_type',
        grouping: [AggregationGroup.year, AggregationGroup.week],
        timespan: { weeks: 12 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Weekly Playtime by licence',
        subtitle: 'Time displayed in hours (hh:mm:ss)',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.licences,
        grouping: [AggregationGroup.year, AggregationGroup.week],
        timespan: { weeks: 12 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Weekly Users by type',
        metric: AnalyticsMetric.active_users,
        datasets: 'label_type',
        grouping: [AggregationGroup.year, AggregationGroup.week],
        timespan: { weeks: 12 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Weekly Users by licence',
        metric: AnalyticsMetric.active_users,
        datasets: AggregationGroup.licences,
        grouping: [AggregationGroup.year, AggregationGroup.week],
        timespan: { weeks: 12 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Daily Playtime by type',
        subtitle: 'Time displayed in hours (hh:mm:ss)',
        metric: AnalyticsMetric.time,
        datasets: 'label_type',
        grouping: [AggregationGroup.year, AggregationGroup.month, AggregationGroup.day],
        timespan: { days: 21 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Daily Playtime by licence',
        subtitle: 'Time displayed in hours (hh:mm:ss)',
        metric: AnalyticsMetric.time,
        datasets: AggregationGroup.licences,
        grouping: [AggregationGroup.year, AggregationGroup.month, AggregationGroup.day],
        timespan: { days: 21 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Daily Users by type',
        metric: AnalyticsMetric.active_users,
        datasets: 'label_type',
        grouping: [AggregationGroup.year, AggregationGroup.month, AggregationGroup.day],
        timespan: { days: 21 }
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Daily Users by licence',
        metric: AnalyticsMetric.active_users,
        datasets: AggregationGroup.licences,
        grouping: [AggregationGroup.year, AggregationGroup.month, AggregationGroup.day],
        timespan: { days: 21 }
      }
    },

    {
      component: 'table',
      settings: {
        title: 'Registered Users by licence and region',
        metric: AnalyticsMetric.users,
        grouping: AggregationGroup.licences,
        datasets: 'label_region',
        totalRow: true,
        totalColumn: true
      }
    },

    {
      component: 'table',
      settings: {
        title: 'Registered Users by licence and region (relative)',
        metric: AnalyticsMetric.users,
        grouping: AggregationGroup.licences,
        datasets: 'label_region',
        totalRow: true,
        totalColumn: true,
        relative: true
      }
    },

    {
      component: 'table',
      settings: {
        title: 'Active Users by licence and region',
        subtitle: 'Users who use the application',
        metric: AnalyticsMetric.active_users,
        grouping: AggregationGroup.licences,
        datasets: 'label_region',
        totalRow: true,
        totalColumn: true
      }
    },

    {
      component: 'table',
      settings: {
        title: 'Active Users by licence and region (relative)',
        subtitle: 'Users who use the application',
        metric: AnalyticsMetric.active_users,
        grouping: AggregationGroup.licences,
        datasets: 'label_region',
        totalRow: true,
        totalColumn: true,
        relative: true
      }
    },

    {
      component: 'table',
      settings: {
        title: 'Playtime by licence and region',
        subtitle: 'Time displayed in hours (hh:mm:ss)',
        metric: AnalyticsMetric.time,
        grouping: AggregationGroup.licences,
        datasets: 'label_region',
        totalRow: true,
        totalColumn: true
      }
    },

    {
      component: 'table',
      settings: {
        title: 'Playtime by licence and region (relative)',
        metric: AnalyticsMetric.time,
        grouping: AggregationGroup.licences,
        datasets: 'label_region',
        totalRow: true,
        totalColumn: true,
        relative: true
      }
    },

    {
      component: 'table',
      settings: {
        title: 'Registered Users by licence and type',
        metric: AnalyticsMetric.users,
        grouping: AggregationGroup.licences,
        datasets: 'label_type',
        totalRow: true,
        totalColumn: true
      }
    },

    {
      component: 'table',
      settings: {
        title: 'Registered Users by licence and type (relative)',
        metric: AnalyticsMetric.users,
        grouping: AggregationGroup.licences,
        datasets: 'label_type',
        totalRow: true,
        totalColumn: true,
        relative: true
      }
    },

    {
      component: 'table',
      settings: {
        title: 'Active Users by licence and type',
        metric: AnalyticsMetric.active_users,
        grouping: AggregationGroup.licences,
        datasets: 'label_type',
        totalRow: true,
        totalColumn: true
      }
    },

    {
      component: 'table',
      settings: {
        title: 'Active Users by licence and type (relative)',
        metric: AnalyticsMetric.active_users,
        grouping: AggregationGroup.licences,
        datasets: 'label_type',
        totalRow: true,
        totalColumn: true,
        relative: true
      }
    },

    {
      component: 'table',
      settings: {
        title: 'Playtime by licence and type',
        subtitle: 'Time displayed in hours (hh:mm:ss)',
        metric: AnalyticsMetric.time,
        grouping: AggregationGroup.licences,
        datasets: 'label_type',
        totalRow: true,
        totalColumn: true
      }
    },

    {
      component: 'table',
      settings: {
        title: 'Playtime by licence and type (relative)',
        metric: AnalyticsMetric.time,
        grouping: AggregationGroup.licences,
        datasets: 'label_type',
        totalRow: true,
        totalColumn: true,
        relative: true
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Video Plays',
        filter: {
          [AggregationGroup.feature]: 'video'
        },
        metric: AnalyticsMetric.media_plays,
        grouping: AggregationGroup.path
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Podcast Plays',
        filter: {
          [AggregationGroup.feature]: 'podcast'
        },
        metric: AnalyticsMetric.media_plays,
        grouping: AggregationGroup.path
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Quiz Games by Licence',
        metric: AnalyticsMetric.games_played,
        grouping: AggregationGroup.licences
      }
    },

    {
      component: 'barChart',
      settings: {
        title: 'Returning Users by licence',
        subtitle: 'Inactive players who returned by then',
        metric: AnalyticsMetric.active_threshold,
        grouping: AggregationGroup.licences,
        timespan: { months: 3 },
        timedelta: { months: 1 }
      }
    }
  ]
};

export default content;
